import React, { forwardRef } from 'react'
import ActorHistoryView from '../ActorHistoryView'
import ActorTimeline from '../ActorV2TimelineView'
import { Details } from '../../common/Details'
import { DetailsSection } from '../DetailsSection'

const GroupAssociationDetails = forwardRef(({ actorHistory, mergedUnc }, ref) => {
  if (actorHistory && actorHistory.history?.length === 0 && actorHistory.suspectedGroups?.length === 0) {
    return (
      <DetailsSection ref={ref} title="Group Associations">
        <Details>
          There are no known confirmed, suspected, or possible group associations at this time.
        </Details>
      </DetailsSection>
    )
  }
  return (
    <DetailsSection ref={ref} title="Group Associations">
      <Details>
        <ActorTimeline actorAncestryData={actorHistory}/>
        <ActorHistoryView actorAncestryData={actorHistory} mergedUnc={mergedUnc}/>
      </Details>
    </DetailsSection>
  )
})

GroupAssociationDetails.displayName = 'GroupAssociationDetails'

export default GroupAssociationDetails
